import axiosInstance from "../libs/axiosInstance";

/**
 * Submit quiz feedback (helpful vote + optional suggestion text)
 * POST /question_bank/quizzes/<quiz_id>/feedback/
 * @param {string} quizId
 * @param {object} payload - { is_helpful: boolean, feedback_text?: string }
 */
export const submitQuizFeedback = async (quizId, payload) => {
  try {
    const response = await axiosInstance.post(
      `/question_bank/quizzes/${quizId}/feedback/`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Error submitting quiz feedback:', error);
    throw error;
  }
};

/**
 * Submit a question helpfulness rating (thumbs up / thumbs down)
 * @param {string} questionId
 * @param {string} sessionId
 * @param {string} rating - "up" or "down"
 */
export const submitQuestionRating = async (questionId, sessionId, rating) => {
  try {
    const response = await axiosInstance.post('/account/question-feedback/', {
      question_id: questionId,
      session_id: sessionId,
      rating,
    });
    return response.data;
  } catch (error) {
    console.error('Error submitting question rating:', error);
    throw error;
  }
};

/**
 * Fetch admin quiz feedback list for a specific quiz
 * GET /question_bank/quizzes/<quiz_id>/feedback/admin/
 * @param {string} quizId
 */
export const getAdminQuizFeedback = async (quizId) => {
  try {
    const response = await axiosInstance.get(
      `/question_bank/quizzes/${quizId}/feedback/admin/`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching admin quiz feedback:', error);
    throw error;
  }
};

/**
 * Fetch top feedbacks (admin view)
 * GET /question_bank/feedbacks/top/
 */
export const getAdminTopFeedbacks = async () => {
  try {
    const response = await axiosInstance.get('/question_bank/feedbacks/top/');
    return response.data;
  } catch (error) {
    console.error('Error fetching top feedbacks:', error);
    throw error;
  }
};
